/**
 * @fileoverview React edit form for event feed messages.
 */

import React, { useEffect, useRef } from 'react';

export interface MessageEditProps {
  onCancel?: () => void;
  onChange?: (value: string) => void;
  onSave?: () => void;
  value?: string;
}

const TEXTAREA_MAX_HEIGHT = 140;

const MessageEdit: React.FC<MessageEditProps> = ({ onCancel, onChange, onSave, value = '' }) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (!textarea) {
      return;
    }

    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, TEXTAREA_MAX_HEIGHT)}px`;
    textarea.style.overflowY = textarea.scrollHeight > TEXTAREA_MAX_HEIGHT ? 'auto' : 'hidden';
  }, [value]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSave?.();
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <div className="bl-card_section-bottom bl-message_edit">
      <form onSubmit={handleSubmit}>
        <div className="bl-message_edit_textarea-wrapper">
          <textarea
            ref={textareaRef}
            name="message"
            onChange={handleChange}
            placeholder=""
            rows={1}
            style={{ maxHeight: `${TEXTAREA_MAX_HEIGHT}px` }}
            value={value}
          />
        </div>
        <div className="bl-card_section_bottom">
          <button className="bl-button bl-message_edit_save-btn" type="submit">
            Save
          </button>
          <button className="bl-button bl-message_edit_cancel-btn" onClick={onCancel} type="button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default MessageEdit;
